import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { history, store } from "../../../../../store/store";
import {
  ROUTE_CLIENT_TICKETS_VIEW,
} from "../../../../../config/routes";
import { ACL } from "../../../../../config/constants";
import { hideNotification } from '../../../../../store/actions/notification';

function ViewTicket(props) {
  const { index, ticket } = props;

  const shouldHideActionBtn = () => {
    if (! ticket || ! ACL.CLIENT.TICKETS.MANAGE.hasAccess()) {
      return false;
    }
  }

  if ( shouldHideActionBtn()) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`view-icon-${index}`}
        onClick={(e) => {
          e.preventDefault();
          store.dispatch(hideNotification());
          let url = ROUTE_CLIENT_TICKETS_VIEW;
          url = url.replace( ":ticketId", ticket.id );
          history.push( url );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${index}`}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage id="button.view"/>
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { ViewTicket };
